export const GET_ONE = "GET_ONE";
export const GET_ONEPUBLIC = "GET_ONEPUBLIC";
export const GET_LOGS = "GET_LOGS";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const SET_SAVE = "SET_SAVE";
export const SET_MODAL = "SET_MODAL";
export const UPDATE_ICONS = "UPDATE_ICONS";

